// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pending-tasks table td[data-v-04a65cbb]:not(:last-child),\r\n.pending-tasks table td.mat-cell[data-v-04a65cbb] {\r\n    border-right: solid 1px rgb(0, 0, 0, 0.12) !important;\n}\n.pending-tasks table td[data-v-04a65cbb] {\r\n    border-bottom: solid 1px rgb(0, 0, 0, 0.12) !important;\n}\n.pending-tasks tbody[data-v-04a65cbb]:hover {\r\n    background-color: #eee;\n}\r\n", ""]);
// Exports
module.exports = exports;
